module.exports = __webpack_public_path__ + "img/customer_value.4a0fd5ac.png";